import { render, staticRenderFns } from "./ResourcesMonitoringHeader.vue?vue&type=template&id=1b0a1500&"
import script from "./ResourcesMonitoringHeader.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoringHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports